import { type ComponentPropsWithoutRef } from 'react'
import { ActionIconSlot } from '@renderer/components/action-icon-slot'
import { useSkillById } from '@renderer/chat/hooks/useSkills'
import { useSkillIcon } from '@renderer/components/skill-icon'

interface ConversationSkillIconProps extends Omit<
  ComponentPropsWithoutRef<typeof ActionIconSlot>,
  'children' | 'view'
> {
  skillId: string
}

export function ConversationSkillIcon({ skillId, ...slotProps }: ConversationSkillIconProps) {
  const { data: skill } = useSkillById(skillId)
  const { Icon, color } = useSkillIcon(skill ?? { metadata: null })

  return (
    <ActionIconSlot {...slotProps}>
      <Icon aria-hidden="true" style={{ color }} />
    </ActionIconSlot>
  )
}
